// Adapted from https://stackoverflow.com/a/36862446

import { useState, useEffect } from 'react';

const TAILWIND_BREAKPOINT_MD_PX = 768;

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
        isDesktop: width >= TAILWIND_BREAKPOINT_MD_PX,
    };
}

export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
